import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./Pages/Home";

import MessageInner from "./Pages/MessageInner";
import Layout from "./utlis/Layout";
import EventInner from "./Pages/EventInner";
import NewsInner from "./Pages/NewsInner";
import TopperInnerX from "./Pages/results/TopperInnerX";
import TopperInnerXII from "./Pages/results/TopperInnerXII";
import GalleryInner from "./Pages/GalleryInner";
import SubGallery from "./Pages/SubGallery";
import About from "./Pages/About";
import VisionMission from "./Pages/about_us/VisionMission";
import Moto from "./Pages/about_us/Moto";
import RecommendationParents from "./Pages/policies/RecommendationParents";
import SpecialInstruction from "./Pages/students/SpecialInstruction";
import GeneralRules from "./Pages/policies/GeneralRules";

import SchoolUniform from "./Pages/policies/SchoolUniform";
import FeeStructure from "./Pages/students/FeeStructure";
import AcademicReg from "./Pages/students/AcademicReg";
import Admission from "./Pages/students/Admission";
import Withdrawal from "./Pages/students/Withdrawal";
import Curriculum from "./Pages/students/Curriculum";
import BusFacility from "./Pages/students/BusFacility";
import Curricular from "./Pages/students/Curricular";
import Infirmary from "./Pages/students/Infirmary";
import Infrastructure from "./Pages/about_us/Infrastructure";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout></Layout>,

      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "/:category",
          element: <MessageInner></MessageInner>,
        },
        {
          path: "/Eventinner",
          element: <EventInner></EventInner>,
        },
        {
          path: "/NewsInner",
          element: <NewsInner></NewsInner>,
        },
        {
          path: "/topperX",
          element: <TopperInnerX></TopperInnerX>,
        },
        {
          path: "/topperXII",
          element: <TopperInnerXII></TopperInnerXII>,
        },
        {
          path: "/galleryinner",
          element: <GalleryInner></GalleryInner>,
        },
        {
          path: "/subGallery/:_id",
          element: <SubGallery></SubGallery>,
        },
        {
          path: "/about",
          element: <About></About>,
        },
        {
          path: "/vision-mission",
          element: <VisionMission></VisionMission>,
        },
        {
          path: "/moto",
          element: <Moto></Moto>,
        },
        {
          path: "/recommendation-to-parent",
          element: <RecommendationParents></RecommendationParents>,
        },
        {
          path: "special-instruction",
          element: <SpecialInstruction></SpecialInstruction>,
        },
        {
          path: "general-rules",
          element: <GeneralRules></GeneralRules>,
        },
        {
          path: "school-uniform",
          element: <SchoolUniform></SchoolUniform>,
        },
        {
          path: "fee-structure",
          element: <FeeStructure></FeeStructure>,
        },
        {
          path: "academic-registration",
          element: <AcademicReg></AcademicReg>,
        },
        {
          path: "/admission",
          element: <Admission></Admission>,
        },
        {
          path: "/withdrawal",
          element: <Withdrawal></Withdrawal>,
        },
        {
          path: "/curriculum",
          element: <Curriculum></Curriculum>,
        },
        {
          path: "/bus-facility",
          element: <BusFacility></BusFacility>,
        },
        {
          path: "/curricular",
          element: <Curricular></Curricular>,
        },
        {
          path: "/infirmary",
          element: <Infirmary></Infirmary>,
        },
        {
          path: "/infrastructure",
          element: <Infrastructure></Infrastructure>,
        },
      ],
    },
  ]);
  return (
    <>
      <RouterProvider router={router}></RouterProvider>
    </>
  );
}

export default App;
